import request from '../utils/request';

// const ip_port = process.env.OPEN_API;
const ip_port = process.env.BASE_URL_OPENAPI
const ip_port_pc = process.env.BASE_URL_PC_API

export default {

  queryZhfwlb(params) {
    return request.get('/zwmk/kh/zhfwlb', params);
  },

  queryCzfwlb(params) {
    return request.get('/open/kh/zhfwlb', params);
  },

  queryQf(params) {
    return request.get('/zwmk/kh/qfxx', params);
  },

  queryJldbnyl(params) {
    return request.get('/khmk/kh/jld/bnyl', params);
  },

  queryKhjldyl(params) {
    return request.get('/zwmk/kh/jldyl', params);
  },

  queryJyls(params) {
    return request.get('/zwmk/kh/jyls', params);
  },

  queryJldfwlbbz() {
    return request.get('/zwmk/kh/jldfwlbbz');
  },

  queryBdzlmx(params) {
    return request.get('/zwmk/hsmk/jldbdmxcx', params);
  },

  updateBdlr(params) {
    return request.post('/zwmk/hsmk/bdlr', params);
  },

  getBdmxList(params) {
    return request.get('/zwmk/hsmk/hsjldbdcx', params);
  },

  xzmk_qfcx(params) {
    return request.get('/zwmk/xzmk/xzmk_qfcx', params);
  },

  dsfzf_zjdd(zwZfddb, zwDdmxbList) {
    const params = { zwZfddb, zwDdmxbList };
    return request.post('/zwmk/dsfzf/dsfzf_zjdd', params);
  },

  dsfzf_cxdd(params) {
    return request.get('/zwmk/dsfzf/dsfzf_cxdd', params);
  },

  dsfzf_xgdd(params) {
    return request.post('/zwmk/dsfzf/dsfzf_xgdd', params);
  },

  wxmp_cxkhjld(params) {
    return request.get('/zwmk/wxmp/wxmp_cxkhjld', params);
  },

  wxmp_cxkhjldyl(params) {
    return request.get('/zwmk/wxmp/wxmp_cxkhjldyl', params);
  },

  zwtjcx_sfjlcx(params) {
    return request.get('/zwmk/zwtjcx/zwtjcx_sfjlcx', params);
  },

  zwtjcx_sfmxcx(params) {
    return request.get('/zwmk/zwtjcx/zwtjcx_sfmxcx', params);
  },

  qxgl_dmyscx(params) {
    return request.get('/zwmk/qxgl/qxgl_dmyscx', params);
  },

  gzhXz(params) {
    return request.post('/zwmk/gzhXz', params);
  },

  fpglKpidwh(params) {
    return request.post('/kprxxwh/fpglKpidwh', params);
  },

  fpgl_cxfpxx(params) {
    return request.get('/fpgl_cxfpxx/fpgl_cxfpxx', params);
  },

  fpgl_gtfpcx(params) {
    return request.get(ip_port_pc + '/fpgl_gtfpcx/fpgl_gtfpcx', params);
  },

  queryFpxx(params) {
    return request.get(ip_port + '/open/invoice/queryfpxx', params);
  },

  queryFpmx(params) {
    return request.get(ip_port + '/open/invoice/queryfpmx', params);
  },

  requestInvoice(data) {
    return request.post(ip_port + '/open/tax/requestInvoice', data);
  },

  querySerialByOrderId(data) {
    return request.post(ip_port + '/open/tax/querySerialByOrderId', data);
  },

  updatefpxx(params) {
    return request.get(ip_port + '/open/invoice/updatefpxx', params);
  },

  requestResultByOrderNo(data) {
    return request.post(ip_port + '/open/tax/QueryFplshByOrderNo', data);
  },

  InvoiceInvalidated(data) {
    return request.post(ip_port + '/open/tax/InvoiceInvalidated', data);
  },

  invoice_red_apply(data) {
    return request.post(ip_port + '/open/tax/invoice_red_apply', data);
  },

  gtsfRequestInvoice(data) {
    return request.post(ip_port + '/open/tax/gtsfRequestInvoice', data);
  },

  requestInvoiceZf(data) {
    return request.post(ip_port + '/open/tax/requestInvoiceZf', data);
  },

  zwmk_wczxxcx(params) {
    return request.get('/zwmk/zwmk_wczxxcx', params);
  },
};



// WEBPACK FOOTER //
// ./src/api/zwmk.api.js